import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'

import { MenuItem, MenuGroup } from '@/core/models/Menu'
import { ADD_MENU_ITEM, FETCH_MENU_LIST, UPDATE_MENU_ITEM } from '@/store/root/actions'
import { GET_MENU_LIST, IS_MENU_DIALOG_SHOWN } from '@/store/root/getters'
import { SET_MENU_DIALOG_SHOWN } from '@/store/root/mutations'


@Component
export default class MenuChangeDialog extends Vue {
  public menuItem = new MenuItem()

  public errorMessage = ''

  public isLoading = false

  public rules: any = {
    required: (value: any) => !!value || 'Требуется указать',
    valid_number: (str: any) => (!isNaN(str) && !isNaN(parseFloat(str))) || 'Неверное число',
  }

  /**
   * Property that indicates ID of changed menu item.
   */
  @Prop({ default: null })
  public item: MenuItem | null;

  /**
   * Property that indicates mode of dialog: `add` or `change`
   */
  @Prop({ default: 'add' })
  public mode: string;

  /**
   * Get is user dialog shown flag, based on global Vuex state.
   */
  @Getter(IS_MENU_DIALOG_SHOWN)
  public isMenuDialogShown: boolean

  /**
   * Sets is user dialog shown flag state.
   */
  @Mutation(SET_MENU_DIALOG_SHOWN)
  public setMenuDialogShown: (isMenuDialogShown: boolean) => void

  /**
   * Fetch users list.
   */
  @Action(FETCH_MENU_LIST)
  public fetchMenuList: () => void;

  /**
   * Get users list, based on global Vuex state.
   */
  @Getter(GET_MENU_LIST)
  public getMenuList: MenuGroup[]

  /**
   * Add user item.
   */
  @Action(ADD_MENU_ITEM)
  public addMenuItem:
    /**
     * @param item   Menu item to add.
     *
     * @return   Resolved promise.
     */
    (item: MenuItem) => Promise<void>

  /**
   * Update menu item.
   */
  @Action(UPDATE_MENU_ITEM)
  public updateMenuItem:
    /**
     * @param item   Menu item to update.
     *
     * @return   Resolved promise.
     */
    (item: MenuItem) => Promise<void>

  public get isFormValid (): boolean {
    if (!this.menuItem) return false
    if (!this.menuItem.title) return false
    // if (!this.menuItem.extraPrice) return false
    if (this.mode === 'add') {
      if (!this.menuItem.groupId) return false
    }
    return true
  }

  /**
   * Create new menu item.
   */
  public async addItem () {
    console.log('addMenuItem')
    this.errorMessage = ''
    this.isLoading = true
    try {
      await this.addMenuItem(this.menuItem!)
      // await this.fetchMenuList()
    } catch (error) {
      this.isLoading = false
      this.errorMessage = 'При добавлении блюда произошла ошибка, попробуйте снова'
      console.log(error)
      return
    }

    this.isLoading = false
    this.$router.go(0)
  }

  /**
   * Change menu item.
   */
  public async updateItem () {
    console.log('update menu item')
    this.errorMessage = ''
    this.isLoading = true
    try {
      await this.updateMenuItem(this.menuItem!)
    } catch (error) {
      this.isLoading = false
      this.errorMessage = 'При редактировании блюда произошла ошибка, попробуйте снова'
      console.log(error)
      return
    }

    this.isLoading = false
    this.setMenuDialogShown(false)
  }

  /**
   * Watch value of dialog`s shown state.
   *
   * @param value   New state value.
   */
  @Watch('isMenuDialogShown')
  public onShownChanged (value: boolean) {
    console.log(`isMenuDialogShown changed!! (value=${value}, mode: ${this.mode})`)
    console.log(this.item)
    if (!value) { return }

    if (this.mode === 'add') {
      this.menuItem = new MenuItem()
    }
    if (this.mode === 'change' && this.item?.id) {
      const group = this.getMenuList.find((group) => group.id === this.item!.groupId)
      if (!group) { return }

      const menuItem = group.items.find((item) => item.id === this.item!.id)
      if (!menuItem) { return }
      this.menuItem = { ...menuItem } as MenuItem
    }
  }
}
